let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bFm0o")).then(() => parcelRequire('2QDJi'));